import { render, staticRenderFns } from "./SurveyDetail.vue?vue&type=template&id=2e60a1e4&"
import script from "./SurveyDetail.vue?vue&type=script&lang=js&"
export * from "./SurveyDetail.vue?vue&type=script&lang=js&"
import style0 from "./SurveyDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports